<template>
  <fragment>
    <div class="kt-header__topbar-item quick-start-button-holder">
      <button class="btn btn-ss btn-icon text-ss-primary" @click="fireModal('quick_start_modal')">
        <i class="fa fa-bolt" />
      </button>
    </div>
    <vjs-modal id="quick_start_modal" name="quick_start_modal"
               title="Quick Start"
               icon="fa fa-bolt">
      <quick-start-bar />
    </vjs-modal>
  </fragment>
</template>
<script>
import QuickStartBar from "VuePartials/QuickStart/QuickStartBar.vue";
export default {
  components: { QuickStartBar },
};
</script>

<style lang="scss" scoped>
  .quick-start-button-holder {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    height: 44px;
    cursor: pointer;
    margin-right:1em;
  }
</style>
